'use client'

import { useEffect } from 'react'
import styles from './Partnership.module.scss'
import googleFormService from '@/modules/googleFormService'
import GoogleIcon from '@mui/icons-material/Google'
import Button from '@mui/material/Button'
import Link from 'next/link'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import writtenContentPhoto from './written-content.webp'
import contentTranslationPhoto from './content-translation.webp'

function Page () {
  const v = useTranslations('Partnership')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.title = v('doc-title')
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{v('partnership-title')}</h1>
      <h3 className={styles.subtitle}>{v('partnership-subtitle')}</h3>
      <div className={styles.bottomSection}>
        <div className={styles.section}>
          <h2>{v('written-content-title')}</h2>
          <div>
            <Image
              src={writtenContentPhoto}
              alt={v('written-content-title')}
              width={140.7084 / 3}
              height={55.6354 / 3}
              layout='responsive'
              priority
            />
          </div>
          <p>
            {v('written-content-description')}
          </p>
          <p style={{ marginBottom: '4rem' }}>
            {v('written-content-description-2')}
          </p>
          <div className={styles.linkWrapper}>
            <Link href={googleFormService('partnershipContact')} target='_blank'>
              <Button
                variant={'contained'}
                startIcon={<GoogleIcon />}
                endIcon={<OpenInNewIcon />}
                fullWidth
                style={{ textTransform: 'none' }}
              >
                {v('partner-contact-button')}
              </Button>
            </Link>
          </div>
        </div>
        <div className={styles.section}>
          <h2>{v('content-translation-title')}</h2>
          <div>
            <Image
              src={contentTranslationPhoto}
              alt={v('content-translation-title')}
              width={140.7084 / 3}
              height={55.6354 / 3}
              layout='responsive'
              priority
            />
          </div>
          <p>
            {v('content-translation-description')}
          </p>
          <p>
            {v('content-translation-description-2')}
          </p>
          <div className={styles.linkWrapper}>
            <Link href={googleFormService('partnershipContact')} target='_blank'>
              <Button
                variant={'contained'}
                startIcon={<GoogleIcon />}
                endIcon={<OpenInNewIcon />}
                fullWidth
                style={{ textTransform: 'none' }}
              >
                {v('partner-contact-button')}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page
